// Redux Form
import { reset, SubmissionError } from 'redux-form';

// Redux action
import { sendMessageAction } from '../../../actions/message/sendMessageAction';

async function submit(values, dispatch) {

	let threadId = values.threadId;
	let threadType = values.threadType;
	let type = values.type;
	let content = values.content;

	const result = await dispatch(sendMessageAction(
		threadId,
		threadType,
		content,
		type,
		undefined,
		undefined,
		0,
		undefined,
		values.receiverName,
		values.senderName,
		values.receiverType,
		values.receiverEmail
	));

	// Check if content was blocked by filter
	if (result && result.errorType === 'content_blocked') {
		throw new SubmissionError({
			_error: result.errorMessage || 'No está permitido compartir información de contacto en el chat.'
		});
	}

	// Only reset if successful
	if (result && result.success !== false) {
		dispatch(reset('SendMessage'));
	}
}

export default submit;